<ds-modal [modal]="modal" [title]="'are_you_sure_you_want_to_remove_the_app?' | translate" class="modal-container">
  <div class="row mb-3">
    <div class="col">
      {{ 'removing_app_wont_delete_scan_results' | translate }}
    </div>
  </div>
  <div class="row">
    <div class="col d-flex justify-content-start">
      <div class="row">
        <div class="col-auto">
          <button type="button" ds-button (click)="removeApp()" data-test-id="remove-app">
            {{ 'remove_app' | translate }}
          </button>
        </div>
        <div class="col-auto">
          <button type="button" ds-button [variant]="DsButtonVariants.secondary" (click)="cancelled()" data-test-id="cancel">
            {{ 'label_cancel' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ds-modal>
